import { jsx } from "react/jsx-runtime";
import { Grid, mediaBreakpointMixin, token } from "@zillow/constellation";
import PropTypes from "prop-types";
import "react";
import styled from "styled-components";
import SEOFooterSubmenu from "./SEOFooterSubmenu.esm.js";
const SEOFooterWrapper = styled(Grid).withConfig({
  displayName: "SEOFooter__SEOFooterWrapper",
  componentId: "sc-1txr3v5-0"
})(["> *{position:relative;text-align:center;@media ", "{&:before{content:' ';width:1px;height:24px;position:absolute;top:12px;right:4px;background:", ";}&:last-of-type{&:before{display:none;}}}}"], mediaBreakpointMixin("lg_gte"), token("colors.gray400"));
const SEOFooter = ({
  submenuItems
}) => /* @__PURE__ */ jsx(SEOFooterWrapper, { display: "grid", gridTemplateColumns: {
  default: "repeat(auto-fit, minmax(0, 1fr))",
  md_lte: "repeat(1, minmax(0, 1fr))"
}, gap: "md", children: submenuItems.map((submenuItem) => /* @__PURE__ */ jsx(SEOFooterSubmenu, { ...submenuItem }, submenuItem == null ? void 0 : submenuItem.label)) });
SEOFooter.propTypes = {
  submenuItems: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string,
    links: PropTypes.arrayOf(PropTypes.shape({
      label: PropTypes.string,
      src: PropTypes.string,
      target: PropTypes.string
    }))
  })).isRequired
};
export {
  SEOFooterWrapper,
  SEOFooter as default
};
